import { CheckOutlined } from "@ant-design/icons";

// Квадратен чекбокс 22×22 за редовете на добавки/модификатори в „Промени"
// (EditModifiersModal / AddonGroupsSection)
export const AddonCheckbox = ({ checked }: { checked: boolean }) => (
  <span
    className={`grid h-[22px] w-[22px] flex-shrink-0 place-items-center rounded-[7px] border-2 ${
      checked
        ? "border-pos-accent bg-pos-accent text-white"
        : "border-pos-check bg-pos-card"
    }`}
  >
    {checked && <CheckOutlined className="text-[12px]" />}
  </span>
);
